import { callEdge } from "@/lib/payments/api.ts";

export async function loadAppointmentMtnMomoCapabilities() {
  try {
    const result = await callEdge("mtn-momo-appointment-checkout", { action: "capabilities" });
    if (!Array.isArray(result?.methods)) throw new Error("payment_capabilities_invalid");
    return result.methods.includes("mtn_momo") ? ["mtn_momo"] : [];
  } catch { throw new Error("payment_capabilities_unavailable"); }
}
